import styled from "styled-components";

export const Container = styled.div`
 margin-top: 37px;
 display: grid;
 grid-template-columns: 7% 20% 45% 21%;
 @media (max-width: 1564px) {
    grid-template-columns: 7% 20% 45% 21% !important;
  }  
 @media (max-width: 794px) {
    grid-template-columns: 7% 20% 45% 21% !important;
  } 

`
export const Image = styled.img`
    width: 65px;
    height: 65px;
    border-radius: 10px;
    border: 1px solid grey;  
`
export const ADImage = styled.img`
    width: 668px;
    object-fit:contain;
    @media (max-width: 1524px) {
      width:95% !important;
    }  
    @media (max-width: 1124px) {
        width:90% !important;
      }  
`
export const H3 = styled.h3`
    color: #58595B;
    font-size: 0.91rem;
    margin-top: 12px;
    margin-right: 2px;
    font-weight: 600;
    font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    span{
        color:#2196F3;
    }
    @media (max-width: 1124px) {
        font-size: 12px !important;
      }  

    @media (max-width: 794px) {
        font-size: 10px !important;
      } 
`